export const getPrimaryRoute = (pathname) => {
    return `/${pathname.split('/', 2)[1] || ''}`;
};